export const pieIcon = [
  "24 24",
  `
  <path xmlns="http://www.w3.org/2000/svg" fill="none" stroke="" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M21.21,15.891
	c-2.151,5.086-8.019,7.466-13.105,5.314c-5.087-2.15-7.467-8.018-5.316-13.104C3.787,5.741,5.652,3.854,8,2.83 M22,12
	c0-5.523-4.477-10-10-10v10H22z"/>
`,
];
